import type { JSONSchemaType } from 'ajv';
import { resultTransformers } from 'neo4j-driver';

import type { ExecuteQueryArgs } from '../../types/sdk-types';

type ComponentsResponse = { name: string; versions: [string]; edition: 'enterprise' | 'community' };

export type VersionAndEdition = {
  version: string;
  edition: 'enterprise' | 'community';
  cypherVersions?: string[];
};
/**
 * Procedure documented here
 * https://neo4j.com/docs/operations-manual/current/reference/procedures/
 */
export function getVersionAndEdition(): ExecuteQueryArgs<VersionAndEdition> {
  const query = 'CALL dbms.components() YIELD versions, edition, name;';

  const resultTransformer = resultTransformers.mappedResultTransformer({
    collect(records, summary) {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      const result = records.map((record) => record.toObject() as ComponentsResponse);
      const kernelResult = result.find((r) => r.name === 'Neo4j Kernel');
      const cypherResult = result.find((r) => r.name === 'Cypher');

      return {
        version: kernelResult?.versions[0] ?? '',
        edition: kernelResult?.edition ?? 'community',
        cypherVersions: cypherResult?.versions,
        summary,
      };
    },
  });

  return {
    query,
    parameters: {},
    queryConfig: { resultTransformer, routing: 'READ', database: 'system' },
  };
}

export const versionAndEditionSchema: JSONSchemaType<VersionAndEdition> = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  properties: {
    edition: {
      enum: ['community', 'enterprise'],
      type: 'string',
    },
    version: {
      type: 'string',
    },
    cypherVersions: {
      type: 'array',
      items: { type: 'string' },
      nullable: true,
    },
  },
  type: 'object',
  required: ['edition', 'version'],
};
